import { SimpleTextFormat } from '@/components/element/SimpleTextFormat';
import { Link } from 'react-router-dom';
import { useWorkspaceSalesOrderPhases } from '@/hooks/api/2550_workspace_sales_order_phases';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';

export const WorkspaceSalesOrderPhasesElement = () => {
  const { _w_, me } = useCurrentWorkspace();
  const { data: phases } = useWorkspaceSalesOrderPhases({ identifier: _w_!.identifier });

  return (
    <div className="card mb-4">
      <div className="card-header d-flex align-items-center">
        <div className="col-md-8">
          <h5 className="mb-0">フェーズ名編集（売上）</h5>
        </div>
      </div>
      <div className="card-body pt-0">
        <div className="table-responsive">
          <table className="table align-items-center">
            <thead>
              <tr>
                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">フェーズ名</th>
                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  フェーズ説明（初期設定）
                </th>
                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  システム連携などの留意事項
                </th>
                <th className="text-secondary opacity-7" style={{ width: 55 }}></th>
              </tr>
            </thead>
            <tbody>
              {phases?.map((phase) => (
                <tr key={`sales-phase-${phase.id}`}>
                  <td>
                    <h6 className="mb-0">{phase.label}</h6>
                  </td>
                  <td className="text-secondary text-xs text-wrap">
                    <SimpleTextFormat content={phase.description} />
                  </td>
                  <td className="text-secondary text-xs text-wrap">
                    <SimpleTextFormat content={phase.note || ''} />
                  </td>
                  <td>
                    {me!.admin && (
                      <Link
                        to={`/w/${_w_!.identifier}/setting/workspace_sales_order_phases/${phase.id}/edit`}
                        className="btn btn-icon-only btn-outline-success"
                      >
                        <i className="fas fa-edit text-success text-sm"></i>
                      </Link>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
